import React from 'react';

import { Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

import DestinationProductsDialog from './destination_products_dialog';
import SectionPaper from "../../../common/section_paper";

const SummaryList = ({
                         showDestinationProductsDialog,
                         types,
                         productsByType,
                         products,
                         destinationsList,
                         destinationProducts
                     }) => {

    if (!types || types.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary">
                Brak dodanych produktów.
            </Typography>
        );
    }

    return (
        <Stack spacing={ 3 } sx={ { width: '100%' } }>
            { types?.map((type, index) => {
                const quantityOfType = productsByType[index]
                    ?.map(product => Number(product?.quantity) || 0)
                    ?.reduce((accumulator, current) => accumulator + current, 0);

                if (quantityOfType <= 0) return <></>

                return (
                    <SectionPaper
                        key={ index }
                        title={ `${ type || 'Pozostałe' } - ${ quantityOfType } szt.` }
                        titleAdornment={
                            showDestinationProductsDialog && (
                                <DestinationProductsDialog
                                    type={ type }
                                    destinationsList={ destinationsList }
                                    destinationProducts={ destinationProducts[index] }
                                />
                            )
                        }
                    >
                        <TableContainer component={ Paper } variant="outlined">
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                                        <TableCell>Nazwa produktu</TableCell>
                                        <TableCell align="center" style={ { width: '15%' } }>Liczba szt.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        products[index]?.map((product, productIndex) => (
                                            <TableRow key={ productIndex } hover>
                                                <TableCell sx={ { fontWeight: 500 } }>
                                                    { product?.name }
                                                </TableCell>
                                                <TableCell align="center">
                                                    { product?.quantity }
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </SectionPaper>
                );
            }) }
        </Stack>
    );
};

export default SummaryList;